export const BoxArchiveIcon = (props) => (
  <svg fill="none" height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect
      height={5}
      rx={1}
      stroke={props.color ? props.color : "#055a17"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      width={20}
      x={2}
      y={3}
    />
    <path
      d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"
      stroke={props.color ? props.color : "#055a17"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
    <path
      d="M10 12h4"
      stroke={props.color ? props.color : "#055a17"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);
